export default __webpack_public_path__ + "static/media/V2-CARROUSEL_1.1feddd59.jpg";